module.exports = __webpack_public_path__ + "static/media/dashboard_icon_hover.757d1db5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dashboard_icon_hover.svg
// module id = 171
// module chunks = 0